// extracted by mini-css-extract-plugin
export default {"listText":"ListMenuItem_listText__Q7tJA"};